var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Select", {
    attrs: {
      value: _vm.value,
      label: _vm.label,
      options: _vm.options,
      isVerific: false,
      placeholder: _vm.placeholder,
      startVerific: false
    },
    on: { input: _vm.handleInput }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }